// TODO: preguntar si esta es la mejor forma de colocar los scripts
// Todos se usan?

// import axios from "axios";
import { docReady } from "./modules/tools";
import { headerBehavior } from "./components/header";
import { handleEgoSelects } from "./components/ego-select";
// import { bannerSwiper } from "./components/banner-swiper";
// import { handleTabs, gallerySwiper } from "./components/gallery";
// import { handleTabs2, gallerySwiper2 } from "./components/gallery-with-text";

// axios.defaults.headers.common['X-CSRFToken'] = getCookie('csrftoken');

docReady(() => {
    // only for debug
    console.warn("external-scripts init");

    headerBehavior();
    handleEgoSelects();
    // bannerSwiper();
    // handleTabs();
    // gallerySwiper();
    // handleTabs2();
    // gallerySwiper2();
});